import Immutable from 'immutable';

// constants
import {
  CURRENT_MANAGER_CREATE, CURRENT_MANAGER_CREATE_DONE,
  CURRENT_MANAGER_UPDATE,
  CURRENT_MANAGER_VALIDATE
} from '../constants/currentManagerTypes';

import {
  CURRENT_REP_CREATE, CURRENT_REP_CREATE_DONE,
  CURRENT_REP_UPDATE
} from '../constants/currentRepTypes';

import { CURRENT_USER_FETCH } from '../constants/currentUserTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { PAYMENT_API_RESPONSE_SEND } from '../constants/premiumSubscriptionTypes';

const finishLoading = (state) => state.set('loading', false);

const setUserPremium = (state, action) => {
  if (action.payload && action.payload.premium) {
    return state.setIn(['data', 'premium'], action.payload.premium);
  }
  return state;
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case CURRENT_MANAGER_CREATE:        return httpReducer(state, action);
    case CURRENT_MANAGER_CREATE_DONE:   return finishLoading(state);
    case CURRENT_MANAGER_UPDATE:        return httpReducer(state, action);
    case CURRENT_MANAGER_VALIDATE:      return httpReducer(state, action);
    case CURRENT_REP_CREATE:            return httpReducer(state, action);
    case CURRENT_REP_CREATE_DONE:       return finishLoading(state);
    case CURRENT_REP_UPDATE:            return httpReducer(state, action);
    case CURRENT_USER_FETCH:            return httpReducer(state, action);
    case PAYMENT_API_RESPONSE_SEND:     return setUserPremium(state, action);
    default:                            return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/currentUser.js